import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Start from './components/pages/Start'
import Kontakt from './components/pages/Kontakt'
import Impressum from './components/pages/Impressum'
import Datenschutz from './components/pages/Datenschutz'

import { publicPath } from '../vue.config.js'

const router = new Router({
    base: publicPath,
    mode: 'history',
    routes: [
        // Public routes
        { path: '/', component: Start, alias: '/home' },
        { path: '/kontakt', component: Kontakt },
        { path: '/impressum', component: Impressum },
        { path: '/datenschutz', component: Datenschutz },
        // Admin routes
        {
            path: '/admin',
            component: Start,
            children: [{
                path: 'termine', // route: /admin/termine
                component: Start,
                meta: { requiresAuth: true }
            }]
        }
    ]
})

// eslint-disable-next-line
router.beforeEach((to, from, next) => {

    // eslint-disable-next-line
    // console.log('beforeEach: ' +from.path + ' -> ' + to.path);

    /*
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!auth.loggedIn()) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        } else {
            next() // replace /to also here
        }
    } else {
        // replace /to also here
        next() // make sure to always call next()!
    }
    */

    if (to.path.startsWith('/to/')) {
        next({ path: to.path.substring(3) })
    } else {
        next()
    }
    // always scroll to top while calling a route
    var el = document ? document.getElementsByTagName('main') : null;
    if (el && el[0]) {
        el[0].scrollTop = 0
    }

}) // beforeEach

export default router;
